import { cx } from "class-variance-authority";

import { Button } from "../Button/Button";
import type { ButtonProps } from "../Button/Button";

import * as styles from "./IconButton.module.scss";

export type IconButtonProps = { label?: string; iconSize?: "sm" } & ButtonProps;

export const IconButton = ({
  label,
  iconSize,
  children,
  ...props
}: IconButtonProps) => {
  return (
    <Button
      {...props}
      className={cx(styles.iconButton, props.className, {
        [styles.smallIconButton]: iconSize === "sm",
      })}
    >
      <span
        className={cx({
          [styles.split]: !!label,
          [styles[props.variant || "primary"]]: !!label,
        })}
      >
        {children}
      </span>
      <div>{label}</div>
    </Button>
  );
};

export default IconButton;
